const SKIP_REDIRECT_REG_EXPS = [
    // Actions starts with '.'
    /\/\.[^.]+$/,
];

export const getNormalizedPath = (source: string) => {
    const url = new URL(source, window.location.href);

    const {pathname} = url;

    if (SKIP_REDIRECT_REG_EXPS.some((regExp) => regExp.test(pathname))) {
        return source;
    }

    // To avoid double slash
    url.pathname = (pathname + '/').replace(/\/{2,}/g, '/');

    return `${url.pathname}${url.search}${url.hash}`;
};
